var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type==='bi')?[_c('i',{staticClass:"bi",class:`bi-${_vm.name}`})]:_vm._e(),(_vm.type==='coreui')?[_c('CIcon',{attrs:{"name":`cil-${_vm.name}`}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }